import { render, staticRenderFns } from "./Katalog.vue?vue&type=template&id=e3932e7e&"
import script from "./Katalog.vue?vue&type=script&lang=js&"
export * from "./Katalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sschmidt/Arbeit/DevTool2025/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3932e7e')) {
      api.createRecord('e3932e7e', component.options)
    } else {
      api.reload('e3932e7e', component.options)
    }
    module.hot.accept("./Katalog.vue?vue&type=template&id=e3932e7e&", function () {
      api.rerender('e3932e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/Katalog.vue"
export default component.exports